import { createSlice } from "@reduxjs/toolkit";

let initialFormComponents = [
  {
    stepName: "Request",
    stepTabLabel: "Request",
    stepTabVisible: true,
    stepTabEnabled: true,
    stepCompleted: false,
  },
  {
    stepName: "Personalize",
    stepTabLabel: "Personalize",
    stepTabVisible: false,
    stepTabEnabled: false,
    stepCompleted: false,
  },
  {
    stepName: "Recipient",
    stepTabLabel: "Recipient",
    stepTabVisible: false,
    stepTabEnabled: false,
    stepCompleted: false,
  },
  {
    stepName: "Return",
    stepTabLabel: "Return",
    stepTabVisible: false,
    stepTabEnabled: false,
    stepCompleted: false,
  },
  {
    stepName: "EcardRecipient",
    stepTabLabel: "Recipient",
    stepTabVisible: false,
    stepTabEnabled: false,
    stepCompleted: false,
  },
  {
    stepName: "Approve",
    stepTabLabel: "Approve",
    stepTabVisible: false,
    stepTabEnabled: false,
    stepCompleted: false,
  },
  {
    stepName: "AddToCart",
    stepTabLabel: "Add to Cart",
    stepTabVisible: true,
    stepTabEnabled: false,
    stepCompleted: false,
  },
];

const configureStepComponents = (
  Id,
  cardTypeValue,
  formStepComponents,
  currentStepName = ""
) => {
  if (cardTypeValue !== "nocard") {
    // is not a no card
    formStepComponents[1].stepTabVisible = true; // show personalize tab
    formStepComponents[5].stepTabVisible = true; // show approve tab
    if (cardTypeValue === "ecard") {
      // is ecard
      formStepComponents[4].stepTabVisible = true; // show ecard tab
    } else {
      if (cardTypeValue === "sendtome") {
        // is send to me
        formStepComponents[2].stepTabVisible = true; // show recipient tab
      } else {
        // is send to someone
        formStepComponents[2].stepTabVisible = true; // show recipient tab
        formStepComponents[3].stepTabVisible = true; // show return tab
      }
    }
  } else {
  }

  if (currentStepName) {
    let markedCompleted = false;
    for (const i in formStepComponents) {
      let step = formStepComponents[i];
      if (
        formStepComponents[i].stepName !== currentStepName &&
        !markedCompleted
      ) {
        formStepComponents[i].stepCompleted = true;
        formStepComponents[i].stepTabEnabled = true;
      } else {
        markedCompleted = true;
      }
    }
  }

  if (Id) {
    // override defaults if existing cart item
    formStepComponents[6].stepTabLabel = "Update Cart";
  }

  return formStepComponents;
};

const getNextConfiguratorStep = (currentStep, cardTypeValue) => {
  let nextStep = "";
  if (currentStep === "Request") {
    if (cardTypeValue === "nocard") {
      nextStep = "AddToCart";
    } else {
      nextStep = "Personalize";
    }
  } else if (currentStep === "Personalize") {
    if (cardTypeValue === "ecard") {
      nextStep = "EcardRecipient";
    } else {
      nextStep = "Recipient";
    }
  } else if (currentStep === "Recipient") {
    if (cardTypeValue === "sendtosomeone") {
      nextStep = "Return";
    } else {
      nextStep = "Approve";
    }
  } else if (currentStep === "EcardRecipient" || currentStep === "Return") {
    nextStep = "Approve";
  } else if (currentStep === "Approve") {
    nextStep = "AddToCart";
  }

  return nextStep;
};

const setNextStepProgress = (state) => {
  let newFormStep = getNextConfiguratorStep(
    state.FormStep,
    state.ConfiguratorRequest.DonorRequest.CardTypeValue
  );
  state.FormStep = newFormStep;
  let formStepComponents = initialFormComponents.map((item) => {
    return { ...item };
  });
  state.FormStepComponents = configureStepComponents(
    state.ConfiguratorRequest.DonorRequest.Id,
    state.ConfiguratorRequest.DonorRequest.CardTypeValue,
    formStepComponents,
    newFormStep
  );
};

const configuratorSlice = createSlice({
  name: "configurator",
  initialState: {
    Loaded: false,
    AddingToCart: false,
    FormStep: "Request",
    ConfiguratorRequest: {
      DonorRequest: {},
      CurrentProduct: "nocard",
    },
    FormStepComponents: initialFormComponents,
  },
  reducers: {
    setInitialState: (state, action) => {
      let pageDefaults = action.payload.pageDefaults;
      let initialRequest = action.payload.request;
      let productType = "nocard";

      // set defaults based on page/widget properties or cart data (if available)
      if (initialRequest.DonorRequest.Id) {
        if(initialRequest.DonorRequest.DoNotSignCard == 'False') initialRequest.DonorRequest.DoNotSignCard = false;
        if (initialRequest.DonorRequest.CardTypeValue !== "nocard") {
          productType = "card";
        }
      } else {
        initialRequest.DonorRequest.CardTypeValue = pageDefaults.cardType;
        initialRequest.DonorRequest.Occasion = pageDefaults.occasion;
        initialRequest.DonorRequest.OfferingTime = "consecutivedays";

        if (pageDefaults.cardType !== "nocard") {
          productType = "card";
        }
        
        if(pageDefaults.massType != null) {
          initialRequest.DonorRequest.MassTypeValue = pageDefaults.massType;
        }
        
        initialRequest.DonorRequest.MassQuantity = 1;
      }

      initialRequest.CurrentProduct = productType;
      
      if (initialRequest.DonorRequest.Id) {
        // override defaults if existing cart item
        state.FormStepComponents[6].stepTabLabel = "Update Cart";
      } else {
        initialRequest.DonorRequest.OfferingAmount = initialRequest.Products[productType].SKUPrice;
      }

      // configure steps and form components based on defaults
      let formStepComponents = initialFormComponents.map((item) => {
        return { ...item };
      });
      state.FormStepComponents = configureStepComponents(
        initialRequest.DonorRequest.Id,
        initialRequest.DonorRequest.CardTypeValue,
        formStepComponents
      );

      // override occasion if mass type is gregorian
      if(pageDefaults.massType != null && pageDefaults.massType === 'gregorian') {
        initialRequest.DonorRequest.Occasion = 35;
      }

      state.Loaded = true;
      state.FormStep = "Request";
      state.ConfiguratorRequest = initialRequest;
    },
    setFormStep: (state, action) => {
      let formStepComponents = initialFormComponents.map((item) => {
        return { ...item };
      });
      state.FormStepComponents = configureStepComponents(
        state.ConfiguratorRequest.DonorRequest.Id,
        state.ConfiguratorRequest.DonorRequest.CardTypeValue,
        formStepComponents,
        action.payload
      );
      state.FormStep = action.payload;
    },
    setIntention(state, action) {
      state.ConfiguratorRequest.DonorRequest.Intention = action.payload;
    },
    setCardType(state, action) {
      // update current product and price
      let productType = action.payload;
      if (action.payload !== "nocard") {
        productType = "card";
      }

      state.ConfiguratorRequest.CurrentProduct = productType;
      state.ConfiguratorRequest.DonorRequest.OfferingAmount =
        state.ConfiguratorRequest.Products[productType].SKUPrice;

      // update card type
      state.ConfiguratorRequest.DonorRequest.CardTypeValue = action.payload;

      // update ui based on card type
      let formStepComponents = initialFormComponents.map((item) => {
        return { ...item };
      });
      state.FormStepComponents = configureStepComponents(
        state.ConfiguratorRequest.DonorRequest.Id,
        state.ConfiguratorRequest.DonorRequest.CardTypeValue,
        formStepComponents
      );
    },
    setOfferingTime(state, action) {
      state.ConfiguratorRequest.DonorRequest.OfferingTime = action.payload;
    },
    setMassQuantity(state, action) {
      state.ConfiguratorRequest.DonorRequest.MassQuantity = action.payload;
    },
    setRequest(state, action) {
      const submittedValues = action.payload;

      // update configurator state based on valid submitted values
      // request
      state.ConfiguratorRequest.DonorRequest.CardTypeValue =
        submittedValues.cardType;
      state.ConfiguratorRequest.DonorRequest.Intention =
        submittedValues.intention;

      // mass details
      state.ConfiguratorRequest.DonorRequest.MassQuantity =
        Number(submittedValues.massQuantity);
      state.ConfiguratorRequest.DonorRequest.Occasion =
        submittedValues.occasion;
      state.ConfiguratorRequest.DonorRequest.MassDate =
        submittedValues.massDate;
      state.ConfiguratorRequest.DonorRequest.OfferingTime = submittedValues.offeringTime;
      if(Number(submittedValues.massQuantity) > 4) {
        state.ConfiguratorRequest.DonorRequest.OfferingTime = "consecutivedays";
      } else if(Number(submittedValues.massQuantity) === 1) {
        state.ConfiguratorRequest.DonorRequest.OfferingTime = "sameday";
      }


      state.ConfiguratorRequest.DonorRequest.DateOfDeath = submittedValues.dateOfDeath;
      state.ConfiguratorRequest.DonorRequest.DeceasedRelationship = submittedValues.deceasedRelationship;

      // update ui for new step if card
      if(state.ConfiguratorRequest.DonorRequest.CardTypeValue !== 'nocard') {
        state.AddingToCart = false;
        setNextStepProgress(state);
      } else {
        state.AddingToCart = true;
      }
    },
    setPersonalize(state, action) {
      const submittedValues = action.payload;

      // update configurator state based on valid submitted values
      state.ConfiguratorRequest.DonorRequest.CardSignature =
        submittedValues.cardSignature;
      state.ConfiguratorRequest.DonorRequest.MailDate =
        submittedValues.mailDate;
      state.ConfiguratorRequest.DonorRequest.DoNotSignCard =
        submittedValues.doNotSignCard;
      state.ConfiguratorRequest.DonorRequest.RecipientRelationDeceased = submittedValues.recipientRelationDeceased;

      // update ui for new step
      setNextStepProgress(state);
    },
    setRecipient(state, action) {
      const submittedValues = action.payload;

      // update configurator state based on valid submitted values
      state.ConfiguratorRequest.DonorRequest.SendTo = submittedValues.sendTo;
      
      state.ConfiguratorRequest.DonorRequest.RecipientTitle =
        submittedValues.title;
      state.ConfiguratorRequest.DonorRequest.RecipientFirstName =
        submittedValues.firstName;
      state.ConfiguratorRequest.DonorRequest.RecipientLastName =
        submittedValues.lastName;
      
      // If sendTo is "billing", set all address fields to empty strings
      if (submittedValues.sendTo === "billing" && state.ConfiguratorRequest.DonorRequest.CardTypeValue === "sendtome") {
        state.ConfiguratorRequest.DonorRequest.RecipientAddress1 = "";
        state.ConfiguratorRequest.DonorRequest.RecipientAddress2 = "";
        state.ConfiguratorRequest.DonorRequest.RecipientCity = "";
        state.ConfiguratorRequest.DonorRequest.RecipientStateProvince = "";
        state.ConfiguratorRequest.DonorRequest.RecipientCountry = "";
        state.ConfiguratorRequest.DonorRequest.RecipientZipPostalCode = "";
      } else {
        // Normal address handling for non-billing cases
        state.ConfiguratorRequest.DonorRequest.RecipientAddress1 =
          submittedValues.address1;
        state.ConfiguratorRequest.DonorRequest.RecipientAddress2 =
          submittedValues.address2;
        state.ConfiguratorRequest.DonorRequest.RecipientCountry =
          submittedValues.country;
        if (submittedValues.country === "USA") {
          state.ConfiguratorRequest.DonorRequest.RecipientStateProvince =
            submittedValues.state;
        } else if (submittedValues.country === "Canada") {
          state.ConfiguratorRequest.DonorRequest.RecipientStateProvince =
            submittedValues.province;
        }
        state.ConfiguratorRequest.DonorRequest.RecipientCity =
          submittedValues.city;
        state.ConfiguratorRequest.DonorRequest.RecipientZipPostalCode =
          submittedValues.postalCode;
      }

      // update ui for new step
      setNextStepProgress(state);
    },
    setEcardRecipient(state, action) {
      const submittedValues = action.payload;

      // update configurator state based on valid submitted values
      state.ConfiguratorRequest.DonorRequest.EcardSendToFirstName =
        submittedValues.ecardSendToFirstName;
        state.ConfiguratorRequest.DonorRequest.EcardSendToLastName =
        submittedValues.ecardSendToLastName;
      state.ConfiguratorRequest.DonorRequest.EcardEmail =
        submittedValues.emailAddress;
      state.ConfiguratorRequest.DonorRequest.EcardName =
        submittedValues.ecardName;

      // update ui for new step
      setNextStepProgress(state);
    },
    setUseAddressValue(state, action) {
      state.ConfiguratorRequest.DonorRequest.UseAddress = action.payload;
    },
    setReturn(state, action) {
      const submittedValues = action.payload;

      // update configurator state based on valid submitted values
      state.ConfiguratorRequest.DonorRequest.UseAddress = submittedValues.useAddress;
      state.ConfiguratorRequest.DonorRequest.ReturnTitle = (submittedValues.useAddress === 'custom') ? submittedValues.title : '';
      state.ConfiguratorRequest.DonorRequest.ReturnFirstName = (submittedValues.useAddress === 'custom') ? submittedValues.firstName : '';
      state.ConfiguratorRequest.DonorRequest.ReturnLastName = (submittedValues.useAddress === 'custom') ? submittedValues.lastName : '';
      state.ConfiguratorRequest.DonorRequest.ReturnAddress1 = (submittedValues.useAddress === 'custom') ? submittedValues.address1 : '';
      state.ConfiguratorRequest.DonorRequest.ReturnAddress2 = (submittedValues.useAddress === 'custom') ? submittedValues.address2 : '';
      state.ConfiguratorRequest.DonorRequest.ReturnCountry = (submittedValues.useAddress === 'custom') ? submittedValues.country : '';
      if (submittedValues.country === "USA") {
        state.ConfiguratorRequest.DonorRequest.ReturnStateProvince = (submittedValues.useAddress === 'custom') ? submittedValues.state : '';
      } else if (submittedValues.country === "Canada") {
        state.ConfiguratorRequest.DonorRequest.ReturnStateProvince = (submittedValues.useAddress === 'custom') ? submittedValues.province : '';
      }
      state.ConfiguratorRequest.DonorRequest.ReturnCity = (submittedValues.useAddress === 'custom') ? submittedValues.city : '';
      state.ConfiguratorRequest.DonorRequest.ReturnZipPostalCode = (submittedValues.useAddress === 'custom') ? submittedValues.postalCode : '';

      // update ui for new step
      setNextStepProgress(state);
    },
    setApprove(state, action) {
      // add/update to cart, get cart item id, update mini cart count
      state.AddingToCart = false;
      state.ConfiguratorRequest.DonorRequest.Id = action.payload;
      setNextStepProgress(state);
    },
    setOfferingAmount(state, action) {
      state.ConfiguratorRequest.DonorRequest.OfferingAmount = action.payload;
    },
    setShowCardSignature: (state, action) => {
      state.ConfiguratorRequest.DonorRequest.DoNotSignCard = action.payload;
    },
    setLoggedInDonor: (state, action) => {
      state.ConfiguratorRequest.DonorIsLoggedIn = true;
      state.ConfiguratorRequest.DonorInfo.Title = action.payload.donorInfo.title;
      state.ConfiguratorRequest.DonorInfo.FirstName = action.payload.donorInfo.firstName;
      state.ConfiguratorRequest.DonorInfo.LastName = action.payload.donorInfo.lastName;
      state.ConfiguratorRequest.DonorInfo.Address1 = action.payload.donorInfo.address1;
      state.ConfiguratorRequest.DonorInfo.Address2 = action.payload.donorInfo.address2;
      state.ConfiguratorRequest.DonorInfo.Country = action.payload.donorInfo.country;
      state.ConfiguratorRequest.DonorInfo.StateProvince = action.payload.donorInfo.stateProvince;
      state.ConfiguratorRequest.DonorInfo.City = action.payload.donorInfo.city;
      state.ConfiguratorRequest.DonorInfo.PostalCode = action.payload.donorInfo.postalCode;
    },
  },
});

export const configuratorActions = configuratorSlice.actions;

export default configuratorSlice;
